import React from "react";

const Footer = () => {
  return (
    <div className="text-center p-10 mt-10 bg-gray-100 drop-shadow-xl  absolute w-screen bottom-0 dark:bg-gray-800">
      <h1 className="text-blue-500 font-bold">Gogl@2021</h1>
    </div>
  );
};

export default Footer;
